import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialModule } from '@material/material.module';
import { BatchOperationAddCandidatesToTalentPoolComponent } from '@shared/batch-operation-add-candidates-to-talent-pool/components/batch-operation-add-candidates-to-talent-pool.component';

const components = [BatchOperationAddCandidatesToTalentPoolComponent];

@NgModule({
  declarations: components,
  imports: [CommonModule, MaterialModule],
  exports: components,
})
export class BatchOperationAddCandidatesToTalentPoolModule {}
